import type { LinkOptions } from '@tanstack/react-router';
import type { USER_ROLE_WITHOUT_GUEST_AND_USER } from 'cpool-constants';
import type { ParseKeys } from 'i18next';

import { ROLES } from '~/constants';
import { ROUTE_ROLES } from '~/features/auth/constants/routeRoles';

export type ManagementTab = Pick<LinkOptions, 'search'> &
    Required<Pick<LinkOptions, 'to'>> & {
        includeSearch?: boolean;
        labelKey: ParseKeys<'de'>;
        roles: ReadonlyArray<USER_ROLE_WITHOUT_GUEST_AND_USER>;
    };

export const managementTabs: ReadonlyArray<ManagementTab> = [
    {
        includeSearch: false,
        labelKey: 'managementSubviews.corporationManagement',
        roles: [ROLES.admin],
        to: '/management/corporations',
    },
    {
        includeSearch: false,
        labelKey: 'managementSubviews.divisionManagement',
        roles: [ROLES.division_leader],
        to: '/management/division',
    },
    {
        includeSearch: false,
        labelKey: 'managementSubviews.divisionManagement',
        roles: [ROLES.corporation_director],
        to: '/management/divisions',
    },
    {
        includeSearch: false,
        labelKey: 'managementSubviews.userManagement',
        roles: ROUTE_ROLES.USER_MANAGEMENT,
        search: { organization: [], page: 1, role: [] },
        to: '/management/users',
    },
    {
        includeSearch: false,
        labelKey: 'managementSubviews.partnerManagement',
        roles: [ROLES.admin, ROLES.accountant_manager, ROLES.corporation_director],
        search: { page: 1, partnerLevel: [], search: '' },
        to: '/management/partners',
    },
    {
        labelKey: 'managementSubviews.leadDistribution',
        roles: ROUTE_ROLES.LEAD_DISTRIBUTION,
        to: '/management/distribution',
    },
    {
        labelKey: 'managementSubviews.generalSettings',
        roles: [ROLES.admin, ROLES.email_manager],
        to: '/management/header_footer',
    },
    {
        labelKey: 'managementSubviews.TEMPLATES_DIVISION',
        roles: [ROLES.division_leader],
        to: '/management/templates/division',
    },
    {
        labelKey: 'managementSubviews.TEMPLATES_DIVISION',
        roles: [ROLES.admin, ROLES.email_manager],
        to: '/management/templates/divisions',
    },
    {
        labelKey: 'managementSubviews.TEMPLATES_GENERAL',
        roles: [ROLES.admin, ROLES.email_manager],
        to: '/management/templates/general',
    },
    {
        labelKey: 'managementSubviews.advisers',
        roles: ROUTE_ROLES.ADVISERS,
        search: { page: 1 },
        to: '/management/advisers',
    },
    {
        labelKey: 'managementSubviews.buckets',
        roles: [ROLES.corporation_director],
        to: '/management/bucket/configurations',
    },
];
